import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import dinhKhoanCategoryService from "services/Finance/DinhKhoanCategoryService";
import { cloneDeep } from "lodash";

export const getCateDinhKhoanTree = createAsyncThunk(
  "dinhKhoanCategory/getCateDinhKhoanTree",
  async (data, { rejectWithValue }) => {
    try {
      const response = await dinhKhoanCategoryService.GetTree(data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getCateDinhKhoan = createAsyncThunk(
  "dinhKhoanCategory/getCateDinhKhoan",
  async (_, { rejectWithValue }) => {
    try {
      const response = await dinhKhoanCategoryService.GetCate();
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateCateDinhKhoan = createAsyncThunk(
  "dinhKhoanCategory/updateCateDinhKhoan",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.Update(data);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const createCateDinhKhoan = createAsyncThunk(
  "dinhKhoanCategory/createCateDinhKhoan",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.Create(data);
      if (onSuccess) onSuccess(response.data);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.description || "Error");
    }
  }
);

export const deleteCateDinhKhoan = createAsyncThunk(
  "dinhKhoanCategory/deleteCateDinhKhoan",
  async (data, { rejectWithValue }) => {
    const { onSuccess, id } = data;
    try {
      const response = await dinhKhoanCategoryService.Delete(id);
      if (onSuccess) onSuccess(response);
      return id;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);
export const getCateDinhKhoanById = createAsyncThunk(
  "dinhKhoanCategory/getCateDinhKhoanById",
  async (data, { rejectWithValue }) => {
    const { onSuccess, id } = data;
    try {
      const response = await dinhKhoanCategoryService.GetById(id);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

//danh muc ngam dinh

export const GetAllDanhMucNgamDinh = createAsyncThunk(
  "dinhKhoanCategory/GetAllDanhMucNgamDinh",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.GetAllDanhMucNgamDinh(
        data
      );
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);
export const UpsertDanhMucNgamDinh = createAsyncThunk(
  "dinhKhoanCategory/UpsertDanhMucNgamDinh",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.UpsertDanhMucNgamDinh(
        data
      );
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);
export const XoaDanhMucNgamDinh = createAsyncThunk(
  "dinhKhoanCategory/XoaDanhMucNgamDinh",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.XoaDanhMucNgamDinh(data);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);
//danh muc quy

export const GetAllTaiKhoanNganHang = createAsyncThunk(
  "dinhKhoanCategory/GetAllTaiKhoanNganHang",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.GetAllDanhMucQuy(data);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const GetAllDanhMucQuy = createAsyncThunk(
  "dinhKhoanCategory/GetAllDanhMucQuy",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.GetAllDanhMucQuy(data);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const GetAllDanhMucQuyDto = createAsyncThunk(
  "dinhKhoanCategory/GetAllDanhMucQuyDto",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.GetAllDanhMucQuy(data);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const GetAllDanhMucQuyNganHangDto = createAsyncThunk(
  "dinhKhoanCategory/GetAllDanhMucQuyNganHangDto",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.GetAllDanhMucQuy(data);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);


export const UpsertDanhMucQuy = createAsyncThunk(
  "dinhKhoanCategory/UpsertDanhMucQuy",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.UpsertDanhMucQuy(data);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);
export const XoaDanhMucQuy = createAsyncThunk(
  "dinhKhoanCategory/XoaDanhMucQuy",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.XoaDanhMucQuy(data);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

///Danh m?c k?t chuy?n

export const GetAllDanhMucKetChuyen = createAsyncThunk(
  "dinhKhoanCategory/GetAllDanhMucKetChuyen",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      console.log("nnn");

      const response = await dinhKhoanCategoryService.GetAllDanhMucKetChuyen(
        data
      );
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);
export const UpsertDanhMucKetChuyen = createAsyncThunk(
  "dinhKhoanCategory/UpsertDanhMucKetChuyen",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.UpsertDanhMucKetChuyen(
        data
      );
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);
export const XoaDanhMucKetChuyen = createAsyncThunk(
  "dinhKhoanCategory/XoaDanhMucKetChuyen",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.XoaDanhMucKetChuyen(data);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

///Danh m?c ng�n h�ng

export const GetAllDanhMucNganHang = createAsyncThunk(
  "dinhKhoanCategory/GetAllDanhMucNganHang",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      console.log("nnn");

      const response = await dinhKhoanCategoryService.GetAllDanhMucNganHang(
        data
      );
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);
export const UpsertDanhMucNganHang = createAsyncThunk(
  "dinhKhoanCategory/UpsertDanhMucNganHang",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.UpsertDanhMucNganHang(
        data
      );
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);
export const XoaDanhMucNganHang = createAsyncThunk(
  "dinhKhoanCategory/XoaDanhMucNganHang",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.XoaDanhMucNganHang(data);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

// Danh m?c bi?u thu? ti�u th?

export const GetTreeBieuThue = createAsyncThunk(
  "dinhKhoanCategory/GetTreeBieuThue",
  async (data, { rejectWithValue }) => {
    try {
      const response = await dinhKhoanCategoryService.GetTreeBieuThue(data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetCateBieuThue = createAsyncThunk(
  "dinhKhoanCategory/GetCateBieuThue",
  async (_, { rejectWithValue }) => {
    try {
      const response = await dinhKhoanCategoryService.GetCateBieuThue();
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpdateBieuThue = createAsyncThunk(
  "dinhKhoanCategory/UpdateBieuThue",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.UpdateBieuThue(data);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const CreateBieuThue = createAsyncThunk(
  "dinhKhoanCategory/CreateBieuThue",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await dinhKhoanCategoryService.CreateBieuThue(data);
      if (onSuccess) onSuccess(response.data);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.description || "Error");
    }
  }
);

export const DeleteBieuThue = createAsyncThunk(
  "dinhKhoanCategory/DeleteBieuThue",
  async (data, { rejectWithValue }) => {
    const { onSuccess, id } = data;
    try {
      const response = await dinhKhoanCategoryService.DeleteBieuThue(id);
      if (onSuccess) onSuccess(response);
      return id;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);
export const GetByIdBieuThue = createAsyncThunk(
  "dinhKhoanCategory/GetByIdBieuThue",
  async (data, { rejectWithValue }) => {
    const { onSuccess, id } = data;
    try {
      const response = await dinhKhoanCategoryService.GetByIdBieuThue(id);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  dinhKhoanCateTree: [],
  dinhKhoanCate: [],
  dinhKhoanCateDetail: {
    loading: false,
    data: null,
  },
  DanhMucNgamDinhList: [],
  DanhMucQuyList: [],
  DanhMucQuyDtoList: [],
  DanhMucQuyNganHangDtoList: [],
  DanhMucKetChuyenList: [],
  DanhMucNganHangList: [],
  bieuThueCateTree: [],
  bieuThueCate: [],
  DanhMucTkNganHangList: [],
};

const dinhKhoanCategorySlice = createSlice({
  name: "dinhKhoanCategory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //GetAllDanhMucQuyNganHangDto
      .addCase(GetAllDanhMucQuyNganHangDto.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllDanhMucQuyNganHangDto.fulfilled, (state, action) => {
        state.loading = false;
        state.DanhMucQuyNganHangDtoList = action.payload;
      })
      .addCase(GetAllDanhMucQuyNganHangDto.rejected, (state) => {
        state.loading = false;
      })
      //GetCateBieuThue
      .addCase(GetCateBieuThue.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetCateBieuThue.fulfilled, (state, action) => {
        state.loading = false;
        state.bieuThueCate = action.payload;
      })
      .addCase(GetCateBieuThue.rejected, (state) => {
        state.loading = false;
      })
      //GetTreeBieuThue
      .addCase(GetTreeBieuThue.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetTreeBieuThue.fulfilled, (state, action) => {
        state.loading = false;
        state.bieuThueCateTree = action.payload;
      })
      .addCase(GetTreeBieuThue.rejected, (state) => {
        state.loading = false;
      })
      //GetAllDanhMucNganHang
      .addCase(GetAllDanhMucNganHang.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllDanhMucNganHang.fulfilled, (state, action) => {
        state.loading = false;
        state.DanhMucNganHangList = action.payload;
      })
      .addCase(GetAllDanhMucNganHang.rejected, (state) => {
        state.loading = false;
      })
      //GetAllDanhMucKetChuyen
      .addCase(GetAllDanhMucKetChuyen.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllDanhMucKetChuyen.fulfilled, (state, action) => {
        state.loading = false;
        state.DanhMucKetChuyenList = action.payload;
      })
      .addCase(GetAllDanhMucKetChuyen.rejected, (state) => {
        state.loading = false;
      })
      //GetAllTaiKhoanNganHang
      .addCase(GetAllTaiKhoanNganHang.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllTaiKhoanNganHang.fulfilled, (state, action) => {
        state.loading = false;
        state.DanhMucTkNganHangList = action.payload;
      })
      .addCase(GetAllTaiKhoanNganHang.rejected, (state) => {
        state.loading = false;
      })
      //GetAllDanhMucQuyDto
      .addCase(GetAllDanhMucQuyDto.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllDanhMucQuyDto.fulfilled, (state, action) => {
        state.loading = false;
        state.DanhMucQuyDtoList = action.payload;
      })
      .addCase(GetAllDanhMucQuyDto.rejected, (state) => {
        state.loading = false;
      })
      //
      .addCase(GetAllDanhMucQuy.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllDanhMucQuy.fulfilled, (state, action) => {
        state.loading = false;
        state.DanhMucQuyList = action.payload;
      })
      .addCase(GetAllDanhMucQuy.rejected, (state) => {
        state.loading = false;
      })
      //
      .addCase(GetAllDanhMucNgamDinh.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllDanhMucNgamDinh.fulfilled, (state, action) => {
        state.loading = false;
        state.DanhMucNgamDinhList = action.payload;
      })
      .addCase(GetAllDanhMucNgamDinh.rejected, (state) => {
        state.loading = false;
      })
      //
      .addCase(getCateDinhKhoan.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCateDinhKhoan.fulfilled, (state, action) => {
        state.loading = false;
        state.dinhKhoanCate = action.payload;
      })
      .addCase(getCateDinhKhoan.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getCateDinhKhoanTree.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCateDinhKhoanTree.fulfilled, (state, action) => {
        state.loading = false;
        state.dinhKhoanCateTree = action.payload;
      })
      .addCase(getCateDinhKhoanTree.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateCateDinhKhoan.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCateDinhKhoan.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateCateDinhKhoan.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createCateDinhKhoan.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCateDinhKhoan.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createCateDinhKhoan.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteCateDinhKhoan.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCateDinhKhoan.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteCateDinhKhoan.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getCateDinhKhoanById.pending, (state) => {
        state.dinhKhoanCateDetail = { ...state.dinhKhoanDetail, loading: true };
      })
      .addCase(getCateDinhKhoanById.fulfilled, (state, action) => {
        state.dinhKhoanCateDetail = { data: action.payload, loading: false };
      })
      .addCase(getCateDinhKhoanById.rejected, (state) => {
        state.dinhKhoanCateDetail = {
          ...state.dinhKhoanDetail,
          loading: false,
        };
      });
  },
});

export default dinhKhoanCategorySlice.reducer;
